import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  originalToken: Cookies.get('original_token')
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  originalToken: state => state.originalToken,
  check: state => state.user !== null
}

// The sign-in cookie goes over https only where the app runs on it; the API reads it as a header, so it stays
// readable by JavaScript (#165)
const tokenCookie = (remember) => ({
  expires: remember ? 365 : null,
  secure: typeof location !== 'undefined' && location.protocol === 'https:',
  sameSite: 'lax'
})

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, tokenCookie(remember))
  },

  [types.SAVE_ORIGINAL_TOKEN] (state, { originalToken, remember }) {
    state.originalToken = originalToken
    Cookies.set('original_token', originalToken, tokenCookie(remember))
  },

  [types.REVERT_ORIGINAL_TOKEN] (state) {
    state.token = state.originalToken
    Cookies.set('token', state.originalToken, tokenCookie(false))
    Cookies.remove('original_token')
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    state.originalToken = null

    Cookies.remove('token')
    Cookies.remove('original_token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    state.originalToken = null

    Cookies.remove('token')
    Cookies.remove('original_token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  saveOriginalToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_ORIGINAL_TOKEN, payload)
  },
  
  revertOriginalToken ({ commit, dispatch }) {
    commit(types.REVERT_ORIGINAL_TOKEN)
  },
  
  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.get('/api/user')

      commit(types.FETCH_USER_SUCCESS, { user: data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}